import React, { useState } from 'react';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import { MdOutlineCheckBoxOutlineBlank, MdOutlineCheckBox } from 'react-icons/md';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type DropdownProps = {
    className?: string;
    data: any[];
    selected: boolean[];
    dataKey?: string;
    groupByKey?: string;
    selectedKey?: string;
    disabled?: boolean;
    onSelect: (value: any) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
}

function Dropdown({
    className,
    data,
    selected,
    dataKey,
    groupByKey,
    selectedKey,
    disabled,
    onSelect,
    label,
    placeholder,
    required,
}: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = useOutsideClickHandler(() => setIsOpen(false));

    return (
        <div
            className={disabled
                ? `dropdown-select--disabled ${className}`
                : isOpen
                ? `dropdown-select--open ${className}`
                : `dropdown-select ${className}`
            }
            onClick={() => !disabled && setIsOpen(!isOpen)}
            ref={ref}
        >
            {label &&
                <p className='dropdown-select__label'>
                    {label} {required && '*'}
                </p>
            }
            <div className='dropdown-select__value'>
                <p>{selected.filter(item => item).length} selected</p>
                {!disabled && isOpen &&
                    <div className='dropdown-select__items'>
                        {groupByKey
                        ?   [...new Set(data.map(item => item[groupByKey]))].map(group => (<>
                                <p className='dropdown-select__group'>{group}</p>
                                {data.filter(item => item[groupByKey] === group).map((item, i) => (
                                    <div
                                        key={i}
                                        className={item[selectedKey] ? 'dropdown-select__item--selected' : 'dropdown-select__item'}
                                        onClick={(event) => { event.stopPropagation(); onSelect(item)   ; }}
                                    >
                                        {item[selectedKey]
                                            ? <MdOutlineCheckBox className='dropdown-select__itemCheckbox' />
                                            : <MdOutlineCheckBoxOutlineBlank className='dropdown-select__itemCheckbox' />
                                        }
                                        <p>{dataKey ? item[dataKey] : item}</p>
                                    </div>
                                ))}
                            </>))
                        :   data.map((item, i) => (
                                <div
                                    key={i}
                                    className={selected[i] ? 'dropdown-select__item--selected' : 'dropdown-select__item'}
                                    onClick={(event) => { event.stopPropagation(); onSelect(item); }}
                                >
                                    {selected[i]
                                        ? <MdOutlineCheckBox className='dropdown-select__itemCheckbox' />
                                        : <MdOutlineCheckBoxOutlineBlank className='dropdown-select__itemCheckbox' />
                                    }
                                    <p>{dataKey ? item[dataKey] : item}</p>
                                </div>
                            ))
                        }
                    </div>
                }
                {isOpen
                    ? <FaCaretUp className='dropdown-select__icon' />
                    : <FaCaretDown className='dropdown-select__icon' />
                }
            </div>
        </div>
    );
}

export default Dropdown;